var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendargrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13380",
    "data-name": "Path 13380",
    d: "M20.667,4.231H18V3H16.667V4.231H11.333V3H10V4.231H7.333A1.289,1.289,0,0,0,6,5.462V17.769A1.289,1.289,0,0,0,7.333,19H20.667A1.289,1.289,0,0,0,22,17.769V5.462A1.289,1.289,0,0,0,20.667,4.231Zm0,13.538H7.333V9.154H20.667Zm0-9.846H7.333V5.462H10V6.692h1.333V5.462h5.333V6.692H18V5.462h2.667Z",
    transform: "translate(-6 -3)",
    fill: "#868a97"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendargrey);
export default __webpack_public_path__ + "static/media/calendargrey.d4b2afce4ccf71d447edd57a1bf5e312.svg";
export { ForwardRef as ReactComponent };